<div class="MainPopup" style="width: 500px">
    <div class="text-right" style="cursor: pointer;"><a (click)="close('close')"><i class="fa fa-times"></i></a>
    </div>
    <fieldset class=" w-90 fieldset">
        <legend>Consult</legend>
        <section class="d-flex">
            <div class="mt-10 mx-5 w-50">
                <kendo-label text="Assign To Group"><span style="color:red"> *</span></kendo-label><br>
               <kendo-dropdownlist
                class="dropdown"
                [(ngModel)]="selectedGroup"
                [data]="groups"
                [defaultItem]="groupSelectPlaceHolder"
                textField="name"
                valueField="id"
                (selectionChange)="groupSelectionChange($event)"
              >
              </kendo-dropdownlist>
                <span *ngIf="!isGoupSelected" class="noValue">
                    Required field!
                    Please select group
                </span>
                <br />
            </div>
            <div class="mt-10 mx-5 w-50">
                <kendo-label text="Assign To User"></kendo-label><br>
                <kendo-dropdownlist
                class="dropdown"
                [(ngModel)]="selectedUserGroup"
                [data]="groupUsers"
                [defaultItem]="userGroupSelectPlaceHolder"
                textField="name"
                valueField="id"
                (selectionChange)="userGroupSelectionChange($event)"
                [disabled]="userGroupSelectDisabled"
              >
              </kendo-dropdownlist>
            </div>
        </section>
        <div class="mt-10 mx-5 w-100">
            <kendo-textarea
              class="mt-5"
              placeholder="Add Comment"
              [(ngModel)]="consultComment"
              [rows]="4"
              [cols]="100"
              resizable="both"
            ></kendo-textarea>
          </div>
        <kendo-dialog-actions>
            <button kendoButton (click)="close('close')"> Back
            </button>
            <button [disabled]="!isGoupSelected" kendoButton class="primary-button" (click)="close('submit')">
                Confirm
            </button>
        </kendo-dialog-actions>
    </fieldset>
</div>